<section class="app-splash-card flex flex-1 items-center justify-center px-6 py-12">
	<div class="card flex w-full max-w-[34rem] flex-col">
		<div class="header flex items-center justify-center">
			<img alt="Valstybinė maisto ir veterinarijos tarnyba" class="max-w-24" src="assets/images/logo.svg" />
		</div>
		<div class="flex flex-col items-center gap-3 p-10 text-center">
			<h1 class="title">Nepavyko įkelti sistemos duomenų</h1>
			<p class="message">Pabandykite perkrauti puslapį. Jei klaida kartojasi, kreipkitės į administratorių.</p>
			<div class="mt-4 flex flex-wrap justify-center gap-3">
				<app-button (clicked)="reload()" icon="pi pi-refresh" label="Perkrauti puslapį" severity="primary" />
			</div>
		</div>
	</div>
</section>
